import { IParameters } from '@common/services/settings/parameters.interface';

export const AppSettings: IParameters = {
    title: 'Santander',
    storageNS: 'Santander',
    imagesUrl: '/img/catalog/products/',
    imagesCategoriesUrl: 'img/catalog/categories/web/',

    signInSlideShow: [
        {
            image: '/assets/img/slideshow/back.jpg',
            message: '',
            duration: 5000,
            animation: 'fadeIn',
        },
        {
            image: '/assets/img/slideshow/back.jpg',
            message: '',
            duration: 5000,
            animation: 'fadeIn',
        },
        {
            image: '/assets/img/slideshow/back.jpg',
            message: '',
            duration: 5000,
            animation: 'fadeIn',
        },
        {
            image: '/assets/img/slideshow/back.jpg',
            message: '',
            duration: 5000,
            animation: 'fadeIn',
        },
        {
            image: '/assets/img/slideshow/back.jpg',
            message: '',
            duration: 5000,
            animation: 'fadeIn',
        },
    ],

    roles: {
        administrator: {
            rolesUri: 'administrator',
        },
        commercialManager: {
            rolesUri: 'commercial-manager',
        },
        creditSpecialist: {
            rolesUri: 'credit-specialist',
        },
        participant: {
            rolesUri: 'participant',
            slides: [
                {
                    url: '/assets/img/slides/Banner_Limite_Dispersiones.png',
                    href: null,
                },
                // {
                //     url: '/assets/img/slides/festejando-a-mama.jpg',
                //     href: null,
                // },
                // {
                //     url: '/assets/img/slides/nuevo-iphone.jpg',
                //     href: null,
                // },
                // {
                //     url: '/assets/img/slides/suzuki2024.jpg',
                //     href: null,
                // },
                {
                    url: '/assets/img/slides/Banner_WEB_SA2023_recuerda.jpg',
                    href: null,
                },
                // {
                //     url: '/assets/img/slides/Banner_Apps_SA.png',
                //     href: null,
                // },
                {
                    url: '/assets/img/slides/SA_VencimientoPuntos_Banner.png',
                    href: null,
                },
                {
                    url: '/assets/img/slides/Banner_WEB_SA_VerficiacionInfo.png',
                    href: null,
                },
            ],
        },
    },
};
